/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * A single fiscal ID entry containing the raw value and optional document type.
 * @export
 * @interface SAPFiscalIdEntry
 */
export interface SAPFiscalIdEntry {
    /**
     * The fiscal ID value (for example, a NIF or VAT number). Maximum 255 characters.
     * @type {string}
     * @memberof SAPFiscalIdEntry
     */
    sapValue: string;
    /**
     * Document type hint (for example, NIF or VAT). Optional; if provided, only rules matching this type are evaluated. If omitted, the type is resolved from the first matched regex rule.
     * @type {string}
     * @memberof SAPFiscalIdEntry
     */
    sapType?: string;
}

/**
 * Check if a given object implements the SAPFiscalIdEntry interface.
 */
export function instanceOfSAPFiscalIdEntry(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sapValue" in value;

    return isInstance;
}

export function SAPFiscalIdEntryFromJSON(json: any): SAPFiscalIdEntry {
    return SAPFiscalIdEntryFromJSONTyped(json, false);
}

export function SAPFiscalIdEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): SAPFiscalIdEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sapValue': json['sapValue'],
        'sapType': !exists(json, 'sapType') ? undefined : json['sapType'],
    };
}

export function SAPFiscalIdEntryToJSON(value?: SAPFiscalIdEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sapValue': value.sapValue,
        'sapType': value.sapType,
    };
}

